import gql from 'graphql-tag';

export const PortfolioProjectQuery = gql`
  query PortfolioProjectQuery($slug: String!) {
    ExternallyAccessibleNostosV1Resource {
      getAllProperties(job_name: "portfolio_projects_by_slug", keys: $slug) {
        elements {
          id
        }
      }
    }
  }
`;
